import React from 'react';
import { Outlet, Link as RouterLink } from 'react-router';
import { AppBar, Box, Toolbar, Typography, Container, Button, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../../hooks/useAuth';
import Footer from './Footer';

const AppLayout: React.FC = () => {
  const { logout, isAuthenticated, user, canManageUsers } = useAuth();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="fixed">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Reindeer Web Console
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Button color="inherit" component={RouterLink} to="/" className="nav-link">
              Dashboard
            </Button>
            <Button color="inherit" component={RouterLink} to="/campaigns" className="nav-link">
              Campaigns
            </Button>
            {canManageUsers() && (
              <Button color="inherit" component={RouterLink} to="/users" className="nav-link">
                User Management
              </Button>
            )}
            {isAuthenticated && user && (
              <Typography variant="subtitle1" noWrap component="div" sx={{ mr: 2, ml: 2 }}>
                {user.email ?? user.sub}
              </Typography>
            )}
            <IconButton color="inherit" onClick={logout} aria-label="logout" title="Sign out">
              <LogoutIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      <Container sx={{ mt: 4, mb: 4, flex: 1 }}>
        <Toolbar /> {/* This is important to offset content below the fixed AppBar */}
        <Outlet />
      </Container>
      <Footer />
    </Box>
  );
};

export default AppLayout;
